module.exports = "/assets/64d22a490341c043dcd20e89456b7f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IW.png
// module id = 1489
// module chunks = 0